import React, { Component } from 'react'
import { connect } from "react-redux";
import axios from "axios";
import Swal from "sweetalert2";
import { configuration } from "../appConfig";
import moment from 'moment';
const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
  });
export class PreDamageSVG extends Component {
    constructor(props) {
        super(props);
       this.PreDamage = React.createRef(null);
        this.state = {
            vin: "",
            lang: "",
            words: {},
            loading : false,
            imageSrc: "",
            captureImageName: "",
            extraImageNameArr: [],
            extraImageNameArr_1: [],
            allOtherPartImages : [
                "foggy_L",
                "meglena_D",
                "headlamp_L",
                "headlamp_D",
                "ventilationGrille",
                "emblem",
                "pvcLiningUnderVS_L",
                "pvcLiningUnderVS_D",
                "frontWiperLCover",
                "frontWiperDCover",
                "windscreen",
                "roofRail_L",
                "roofRail_D",
                "roofAntenna",
                "luggageCoverSpoiler",
                "luggageCoverGlass",
                "rearWiperCover",
                "interiorBrakeLight_L",
                "interiorBrakeLight_D",
                "fenderTurnSignal_L",
                "mirrorOutside_L",
                "turnSignalOnExteriorMirror_L",
                "doorHandle_EN",
                "doorTrimLower_EN",
                "slidingWindowTrim_EN",
                "topDoorSash_EN",
                "doorUpright_SL",
                "doorHandle_ZL",
                "doorTrimBelow_ZL",
                "slidingWindowSlat_ZL",
                "topDoorSash_ZL",
                "doorHinge_ZL",
                "zlDoorStile",
                "tankCover",
                "windowTriangle_ZL",
                "brakeLightExternal_L",
                "fenderTurnSignal_D",
                "mirrorOutside_D",
                "turnSignalOnOutsideMirror_D",
                "doorHandle_SD",
                "doorTrimLower_SD",
                "slidingWindowTrim_SD",
                "doorTrimAbove_SD",
                "doorStile_SD",
                "sdDoorHandle",
                "sdDoorTrimBelow",
                "slidingWindowMoulding_ZD",
                "upperDoorLeaf_ZD",
                "zdDoorUpStand",
                "zdDoorStile",
                "windowTriangle_ZD",
                "brakeLightExternal_D",
              ]
        }
    }

    componentDidMount = () => {
        this.getLang();
        this.getPreDamageImages();
    };
    getLang = () => {
        const base_url = window.location.origin;
        axios.get(`${base_url}/lang.json`).then((res) => {
          this.setState({
            words: res.data,
            lang: localStorage.getItem("lang"),
          });
        });
      };
      static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.lang !== prevState.lang) {
          return { lang: nextProps.lang };
        } else return null;
      }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.lang !== prevState.lang) {
          return { lang: nextProps.lang };
        } else return null;
    }

    lang = (word) => {
        const { lang, words } = this.state;
        return words[word] ? words[word][lang] : word;
    };
    
    getLang = () => {
        const base_url = window.location.origin;
        axios.get(`${base_url}/lang.json`).then((res) => {
          this.setState({
            words: res.data,
            lang: localStorage.getItem("lang"),
          });
        });
    };

    getPreDamageImages = () => {
        let partnerId = localStorage.getItem("partnerId");
        const vin = localStorage.getItem("selectedFile");
          const url = `${configuration.getExtraImages}?partnerId=${partnerId}&vin=${vin}&partName=yes`;
          axios
            .get(url)
            .then((res) => {
              let extraImageNameArr_1 = [];
              if (res && res.data.extraNewImages) {
                for (const key in res.data.extraNewImages) {
                  if (Object.hasOwnProperty.call(res.data.extraNewImages, key)) {
                    const element = res.data.extraNewImages[key];
                    const partName = element.name && element.name.split("/")[element.name.split("/").length - 1];
                    extraImageNameArr_1.push(partName);
                  }
                }
                this.setState({
                    extraImageNameArr_1
                });
              }
            })     
            .catch((err) => {
            });
      
    }

    getBase644 = async (file) => {
        return new Promise((resolve, reject) => {
          let reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = async function () {
            resolve(reader.result);
          };
          reader.onerror = function (error) {
            reject(error);
          };
        });
      };

    capture = async (e) => {
        // if (e.target.files.length > 0) {
        //   this.setState(
        //     {
        //       imageSrc: e.target.files[0],
        //     },
        //     () => {
        //       this.props.uploadExtraImagesNew(this.state.imageSrc, this.state.captureImageName, this);
        //     }
        //   );
        // }
        const { files } = e.target;
        const base64 = await this.getBase644(files[0]);
        this.setState({
        imageSrc: base64,
        },
        () => {
            this.props.uploadExtraImagesNew(this.state.imageSrc, this.state.captureImageName, this);
        }
        );
    };

    userClick = (part) => {
        this.setState({
            captureImageName : part,
            imageSrc : ""
        })
        if(!this.fillColor(part)){
            this.PreDamage.click();
        }
    }

    fillColor = (part) => {
        // const { extraImageNameArr_1 } = this.state;
        const { extraImageNameArr_1 } = this.props;
        let partimages = extraImageNameArr_1.filter(item => item.includes(part))
       if(partimages[0]){
            return "#EF3D3C";
        }
    }

  render() {
    return (
     <>

        <input
            type="file"
            name="image"
            id="file"
            // ref="PreDamage"
            ref={(input) => (this.PreDamage = input)}
            accept="image/*"
            capture="environment"
            style={{ display: "none"}}
            onChange={(e) => this.capture(e)}
        />
        
        <svg 
            version="1.1" 
            id="Layer_1" 
            xmlnsx="&ns_extend;" 
            xmlnsi="&ns_ai;" 
            // xmlns:graph="&ns_graphs;"
            xmlns="http://www.w3.org/2000/svg" 
            xmlnsXlink="http://www.w3.org/1999/xlink" 
            x="0px" 
            y="0px" 
            viewBox="0 0 919.5 1207.4"
            style={{enableBackground : "new 0 0 919.5 1207.4"}}
            xmlSpace="preserve">
            <style type="text/css">
                {`  .st0{display:none;fill:#FFFFFF;}
                    .st1{fill:#F8F8F8;}
                    .st2{fill:none;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}
                    .st3{fill:#FFFFFF;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}
                    .st4{fill:#FFFFFF;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}
                    .st5{fill:#FFFFFF;}
                    .st6{fill:#FFFFFF;stroke:#231F20;stroke-width:0.6;stroke-miterlimit:10;}
                    // .st7{fill:#706A58;}
                    .st8{fill:#F8F8F8;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}
                    .st9{stroke:#F8F8F8;stroke-width:0.5;stroke-miterlimit:10;}
                    .st10{fill:none;stroke:#000000;stroke-miterlimit:10;}`}
            </style>

            <g iextraneous="self">
                    <path className="st0" d="M659.5,486.2l127-15l47.5,7.5c0,0,23.5,167,0,247.5c0,0-88.5,6-159-8.5c0,0-17.3,0-13.8-10.5
                        C661.3,707.2,680,498.2,659.5,486.2z"/>
                    <line className="st1" x1="188" y1="160.8" x2="187.5" y2="160.5"/>
                    <path d="M199.5,453.3"/>
                    <g>
                        <line className="st2" x1="68" y1="265.8" x2="68" y2="404"/>
                        <circle className="st3" cx="77.8" cy="335.7" r="59.3"/>
                        <circle className="st3" cx="78.8" cy="334.7" r="36.3"/>
                    </g>
                    <path className="st4" d="M198.3,377.1l70.1,139.2c0,0,12.2,37.8,17.2,78.7c5,41,3.8,206.4,1.6,206.5c0,0-8,24.2-9.8,29.8
                        s-68.5,155.5-68.5,155.5s3.8,25.6-7.6,29.8s-61,0-61,0l-9.7,12.5l-33.7,1.3c0,0-7.3-5.3-14-10.7h-11l-4.5-104.9
                        c0,0,83.2,4.6,80.2-68.7s-85-70.7-89.7-70.3c-4.7,0.3,0-372.7,0-372.7s87,12.8,91-70c0,0-7.8-78.5-93.1-66v-5.8l5.1-0.3l-2-39.3
                        c-0.1,0.2,6.4-40.8,12.3-38.8c17.1,6,23.8-4.5,24.4-7.1h29l5.7,5.5l24.9,13.9c0,0,12.6,10.5,13.4,17.6
                        C169.5,219.8,190.8,249.9,198.3,377.1z"/>
                    <line className="st2" x1="68" y1="776" x2="68" y2="914.2"/>
                    <circle className="st3" cx="77.8" cy="848" r="59.3"/>
                    <path className="st4" d="M275.2,648.5L275,790.1l-74.7,28.3c0,0-35.6,15.4-58.9-17c-23.8-33.2-68-31.7-68-31.7L72,634
                        C72,634,126.1,620.5,275.2,648.5z"/>
                    <ellipse className="st1" cx="159.2" cy="408.5" rx="5.1" ry="13.5"/>
                    <ellipse 
                    style={{ fill: this.fillColor("tankCover")}}
                    onClick={() => this.userClick("tankCover")}
                    className="st3" cx="180.5" cy="920.7" rx="13" ry="18.8"/>
                    <path className="st4" d="M182.5,430.8c0,0,16.8,11.6,28,25.9c10.7,13.6,44.2,74.8,57,126.3c11.8,47.4,8.2,66.8,8.2,66.8
                        c3.5-0.7-152.9-27.7-203.7-15.8L71,446.3c0,0-1.8-16.3,21.9-15.5S182.5,430.8,182.5,430.8z"/>
                    <g>
                        <path d="M169.5,404.8h0.6l0.8,0.8c1.9,2,2.9,2.9,4.1,2.9c0.8,0,1.5-0.4,1.5-1.5c0-0.7-0.4-1.3-0.7-1.7l0.7-0.3
                            c0.5,0.5,0.8,1.3,0.8,2.2c0,1.7-1.2,2.4-2.3,2.4c-1.4,0-2.6-1-4.2-2.7l-0.6-0.6h0v3.5h-0.9V404.8z"/>
                        <path d="M173.5,416.1c-2.7,0-4.1-1-4.1-2.7c0-1.5,1.4-2.6,4-2.6c2.6,0,4.1,1.1,4.1,2.7C177.5,415.2,176,416.1,173.5,416.1z
                            M173.4,411.9c-2,0-3.2,0.6-3.2,1.6c0,1.1,1.3,1.6,3.3,1.6c1.9,0,3.2-0.5,3.2-1.6C176.6,412.5,175.5,411.9,173.4,411.9z"/>
                    </g>
                    <path className="st4" d="M134.1,221.8c0,0,20.9,0.2,27.9,23.7c7.5,25,21.5,123,21.5,123s5.9,26.7,12.9,35.8l1.7-28.6
                        c0,0-1.7,3-0.2,0.7c2.8-4.3-12.7-157.3-38.7-177.3c-13.5-10.4-28.9-17.4-28.9-17.4"/>
                    <path className="st4" d="M134.1,221.8l-1.3,71.5c0,0-21.3-35.8-77.1-26.3v-5.8l5.1-0.3l-2-39.3c1.1,0.3,4.7-34.8,11.9-38.9
                        c0,0,16,8,24.8-6.9h29l5.3,5.7L134.1,221.8z"/>
                    <polyline 
                     style={{ fill: this.fillColor("doorTrimLower_EN")}}
                     onClick={() => this.userClick("doorTrimLower_EN")}
                    className="st3" points="82,448.6 90,448.6 90,455.1 91.9,459.6 91.9,596.6 90,599 89.9,605.8 83.7,605.8 83.7,598.6 
                        80.4,595 80.4,458 82.4,457 82,449.5 		"/>
                    <polyline 
                    style={{ fill: this.fillColor("doorTrimBelow_ZL")}}
                    onClick={() => this.userClick("doorTrimBelow_ZL")}
                    className="st3" points="80,645 88,645 88,649.8 89.9,653.2 89.9,756.1 88,757.8 87.9,763 81.7,763 81.7,757.6 78.4,754.8 
                        78.4,652 80.4,651.2 80,645.6 		"/>
                    <polygon 
                    style={{ fill: this.fillColor("mirrorOutside_L")}}
                    onClick={() => this.userClick("mirrorOutside_L")}
                    className="st3" points="190.2,454 200.9,454 220,483.6 219,500.8 204.9,500 191.9,483 		"/>
                    <polygon 
                    style={{ fill: this.fillColor("turnSignalOnExteriorMirror_L")}}
                    onClick={() => this.userClick("turnSignalOnExteriorMirror_L")}
                    className="st3" points="191.9,483.2 204.8,499.8 204.1,505.7 199.3,506.2 192.5,498.3 		"/>
                    <g>
                        <path d="M179.9,484.8h0.6l0.8,0.8c1.9,2,2.9,2.9,4.1,2.9c0.8,0,1.5-0.4,1.5-1.5c0-0.7-0.4-1.3-0.7-1.7l0.7-0.3
                            c0.5,0.5,0.8,1.3,0.8,2.2c0,1.7-1.2,2.4-2.3,2.4c-1.4,0-2.6-1-4.2-2.7l-0.6-0.6h0v3.5h-0.9V484.8z"/>
                        <path d="M179.9,490.9h0.6l0.8,0.8c1.9,2,2.9,2.9,4.1,2.9c0.8,0,1.5-0.4,1.5-1.5c0-0.7-0.4-1.3-0.7-1.7l0.7-0.3
                            c0.5,0.5,0.8,1.3,0.8,2.2c0,1.7-1.2,2.4-2.3,2.4c-1.4,0-2.6-1-4.2-2.7l-0.6-0.6h0v3.5h-0.9V490.9z"/>
                    </g>
                    <g>
                        <path d="M155,596.3h0.6l0.8,0.8c1.9,2,2.9,2.9,4.1,2.9c0.8,0,1.5-0.4,1.5-1.5c0-0.7-0.4-1.3-0.7-1.7l0.7-0.3
                            c0.5,0.5,0.8,1.3,0.8,2.2c0,1.7-1.2,2.4-2.3,2.4c-1.4,0-2.6-1-4.2-2.7l-0.6-0.6h0v3.5H155V596.3z"/>
                        <path d="M156.2,602.7c-0.2,0.3-0.5,1-0.5,1.7c0,1.4,0.9,1.8,1.5,1.8c1.1,0,1.6-1,1.6-2v-0.6h0.8v0.6c0,0.8,0.4,1.7,1.3,1.7
                            c0.6,0,1.2-0.4,1.2-1.4c0-0.6-0.3-1.2-0.5-1.6l0.8-0.3c0.3,0.4,0.6,1.2,0.6,2c0,1.5-0.9,2.2-1.9,2.2c-0.8,0-1.5-0.5-1.8-1.4h0
                            c-0.2,1-0.9,1.7-2,1.7c-1.2,0-2.3-1-2.3-2.8c0-0.9,0.3-1.6,0.5-2L156.2,602.7z"/>
                    </g>
                    <g>
                        <path d="M155,791.9h0.6l0.8,0.8c1.9,2,2.9,2.9,4.1,2.9c0.8,0,1.5-0.4,1.5-1.5c0-0.7-0.4-1.3-0.7-1.7l0.7-0.3
                            c0.5,0.5,0.8,1.3,0.8,2.2c0,1.7-1.2,2.4-2.3,2.4c-1.4,0-2.6-1-4.2-2.7l-0.6-0.6h0v3.5H155V791.9z"/>
                        <path d="M157,798c1,0,1.7,0.6,2.1,1.5l0,0c0.4-0.9,1.1-1.2,1.8-1.2c1.2,0,2.1,1,2.1,2.4c0,1.5-0.9,2.3-1.9,2.3
                            c-0.7,0-1.4-0.3-1.8-1.3h0c-0.4,1-1.1,1.6-2,1.6c-1.4,0-2.3-1.2-2.3-2.7C154.9,799,155.9,798,157,798z M157.1,802.2
                            c0.9,0,1.4-0.7,1.7-1.7c-0.3-0.9-0.9-1.4-1.6-1.4c-0.8,0-1.5,0.6-1.5,1.6C155.7,801.6,156.2,802.2,157.1,802.2z M161,799.3
                            c-0.8,0-1.2,0.6-1.4,1.5c0.2,0.7,0.7,1.2,1.4,1.2c0.6,0,1.3-0.4,1.3-1.3C162.2,799.8,161.6,799.3,161,799.3z"/>
                    </g>
                    <g>
                        <path d="M184,848.8c-0.2,0.3-0.5,1-0.5,1.7c0,1.4,0.9,1.8,1.5,1.8c1.1,0,1.6-1,1.6-2v-0.6h0.8v0.6c0,0.8,0.4,1.7,1.3,1.7
                            c0.6,0,1.2-0.4,1.2-1.4c0-0.6-0.3-1.2-0.5-1.6l0.8-0.3c0.3,0.4,0.6,1.2,0.6,2c0,1.5-0.9,2.2-1.9,2.2c-0.8,0-1.5-0.5-1.8-1.4h0
                            c-0.2,1-0.9,1.7-2,1.7c-1.2,0-2.3-1-2.3-2.8c0-0.9,0.3-1.6,0.5-2L184,848.8z"/>
                        <path d="M189.7,859.3v-3l-2-0.3c0,0.2,0,0.3,0,0.6c0,0.6-0.1,1.2-0.4,1.7c-0.3,0.6-1,1.1-2,1.1c-1.5,0-2.7-1.2-2.7-2.9
                            c0-0.9,0.2-1.6,0.5-1.9l0.8,0.3c-0.2,0.3-0.4,1-0.4,1.7c0,1,0.6,1.8,1.7,1.8c1,0,1.7-0.7,1.7-2.2c0-0.4,0-0.8-0.1-1.1l3.7,0.5
                            v3.7H189.7z"/>
                    </g>
                    <g>
                        <path d="M178.2,915c-0.2,0.3-0.5,1-0.5,1.7c0,1.4,0.9,1.8,1.5,1.8c1.1,0,1.6-1,1.6-2v-0.6h0.8v0.6c0,0.8,0.4,1.7,1.3,1.7
                            c0.6,0,1.2-0.4,1.2-1.4c0-0.6-0.3-1.2-0.5-1.6l0.8-0.3c0.3,0.4,0.6,1.2,0.6,2c0,1.5-0.9,2.2-1.9,2.2c-0.8,0-1.5-0.5-1.8-1.4h0
                            c-0.2,1-0.9,1.7-2,1.7c-1.2,0-2.3-1-2.3-2.8c0-0.9,0.3-1.6,0.5-2L178.2,915z"/>
                        <path d="M177,924.2h2.1v-3.6h0.7l5,3.5v1.1H180v1.1h-0.8v-1.1H177V924.2z M180,924.2h2.6c0.4,0,0.8,0,1.2,0v0
                            c-0.5-0.2-0.8-0.4-1.2-0.6l-2.7-1.9h0V924.2z"/>
                    </g>
                    <g>
                        <path d="M100.6,525.2h0.6l0.8,0.8c1.9,2,2.9,2.9,4.1,2.9c0.8,0,1.5-0.4,1.5-1.5c0-0.7-0.4-1.3-0.7-1.7l0.7-0.3
                            c0.5,0.5,0.8,1.3,0.8,2.2c0,1.7-1.2,2.4-2.3,2.4c-1.4,0-2.6-1-4.2-2.7l-0.6-0.6h0v3.5h-0.9V525.2z"/>
                        <path d="M100.6,534.6h2.1V531h0.7l5,3.5v1.1h-4.8v1.1h-0.8v-1.1h-2.1V534.6z M103.6,534.6h2.6c0.4,0,0.8,0,1.2,0v0
                            c-0.5-0.2-0.8-0.4-1.2-0.6l-2.7-1.9h0V534.6z"/>
                    </g>
                    <g>
                        <path d="M100.6,701.2h0.6l0.8,0.8c1.9,2,2.9,2.9,4.1,2.9c0.8,0,1.5-0.4,1.5-1.5c0-0.7-0.4-1.3-0.7-1.7l0.7-0.3
                            c0.5,0.5,0.8,1.3,0.8,2.2c0,1.7-1.2,2.4-2.3,2.4c-1.4,0-2.6-1-4.2-2.7l-0.6-0.6h0v3.5h-0.9V701.2z"/>
                        <path d="M101.4,707.9c0,0.2,0,0.5,0,0.9c0.1,0.6,0.3,1.2,0.8,1.6c0.5,0.5,1.2,0.9,2.1,1v0c-0.5-0.4-0.8-1.1-0.8-1.8
                            c0-1.4,1.1-2.3,2.4-2.3c1.5,0,2.8,1.1,2.8,2.7s-1.3,2.6-3.3,2.6c-1.7,0-2.9-0.6-3.7-1.3c-0.6-0.6-0.9-1.4-1-2.3
                            c-0.1-0.4-0.1-0.7-0.1-1H101.4z M105.8,708.3c-1,0-1.7,0.6-1.7,1.5c0,0.7,0.3,1.3,0.8,1.5c0.1,0.1,0.2,0.1,0.4,0.1
                            c1.3,0,2.4-0.5,2.4-1.6C107.7,709,106.9,708.3,105.8,708.3z"/>
                    </g>
                    <path 
                        style={{ fill: this.fillColor("doorHandle_EN")}}
                        onClick={() => this.userClick("doorHandle_EN")}
                    className="st3" d="M169.4,614.7v-22.2c0-3.4,2.7-6.1,6.1-6.1h0c3.4,0,6.1,2.7,6.1,6.1v22.2c0,3.4-2.7,6.1-6.1,6.1h0
                        C172.1,620.8,169.4,618.1,169.4,614.7z"/>
                    <path 
                    style={{ fill: this.fillColor("doorHandle_ZL")}}
                    onClick={() => this.userClick("doorHandle_ZL")}
                    className="st3" d="M169.4,810.1V788c0-3.4,2.7-6.1,6.1-6.1h0c3.4,0,6.1,2.7,6.1,6.1v22.2c0,3.4-2.7,6.1-6.1,6.1h0
                        C172.1,816.2,169.4,813.5,169.4,810.1z"/>
                    <path 
                    style={{ fill: this.fillColor("windowTriangle_ZL")}}
                    onClick={() => this.userClick("windowTriangle_ZL")}
                    className="st3" d="M267.2,799l-66.3,26V876c0,0,7.9,23.5,28.7-7.8S267.2,799,267.2,799z"/>
                    <path 
                    style={{ fill: this.fillColor("brakeLightExternal_L")}}
                    onClick={() => this.userClick("brakeLightExternal_L")}
                    className="st3" d="M160.1,1017.1c0,0,1.8-23,1.8-28.9c0-5.9,6.3-6.6,6.3-6.6s14.3,0,21,0s6,6.6,6,6.6v27.7l0,1.8
                        c0,0-26.3,1.3-35,0V1017.1z"/>
                    <g>
                        <path d="M175.9,995.8c-0.2,0.3-0.5,1-0.5,1.7c0,1.4,0.9,1.8,1.5,1.8c1.1,0,1.6-1,1.6-2v-0.6h0.8v0.6c0,0.8,0.4,1.7,1.3,1.7
                            c0.6,0,1.2-0.4,1.2-1.4c0-0.6-0.3-1.2-0.5-1.6l0.8-0.3c0.3,0.4,0.6,1.2,0.6,2c0,1.5-0.9,2.2-1.9,2.2c-0.8,0-1.5-0.5-1.8-1.4h0
                            c-0.2,1-0.9,1.7-2,1.7c-1.2,0-2.3-1-2.3-2.8c0-0.9,0.3-1.6,0.5-2L175.9,995.8z"/>
                        <path d="M181.7,1006.1c0-0.2,0-0.5,0-0.8c-0.3-1.7-1.5-2.5-2.8-2.7v0c0.5,0.4,0.9,1,0.9,1.9c0,1.4-1,2.3-2.5,2.3
                            c-1.4,0-2.7-1-2.7-2.6c0-1.7,1.3-2.8,3.3-2.8c1.5,0,2.7,0.6,3.5,1.3c0.6,0.6,1,1.5,1.2,2.5c0,0.3,0.1,0.6,0.1,0.8H181.7z
                            M177.2,1005.8c1.1,0,1.8-0.6,1.8-1.6c0-0.6-0.4-1.2-1-1.5c-0.1-0.1-0.3-0.1-0.5-0.1c-1.3,0-2.2,0.6-2.2,1.7
                            C175.3,1005.2,176.1,1005.8,177.2,1005.8z"/>
                    </g>
                    <path className="st4" d="M138.5,884.4l3.7,15.5l-2,116.5l-9.7,12.5l-33.7,1.3l-14-10.7h-11l-5.2-105.4
                        C66.9,914.1,116.7,918.8,138.5,884.4z"/>
                    <path className="st4" d="M268.4,516.3c0,0-5.8,16.5-7.8,20.7c-2,4.2-62.7-116.7-62.7-116.7c-2.2-6-0.9-43.5-0.1-43.9L268.4,516.3z"/>
                    <path className="st4" d="M260.6,537c0,0,10.3,36.6,15.5,70c5.3,33.4,3.1,173.5,2.1,180s-6.6,38.7-10.5,47.5c-3.6,8.2-60,119-60,119
                        s-8,14.8,1,33.3l62-140.3c0,0,11.1-25.9,16.3-45c5.3-19.6,0.9-213-2.2-213c0,0-9.3-57.8-16.7-71.6L260.6,537z"/>
                    <g>
                        <path d="M200.9,476.3h0.6l0.8,0.8c1.9,2,2.9,2.9,4.1,2.9c0.8,0,1.5-0.4,1.5-1.5c0-0.7-0.4-1.3-0.7-1.7l0.7-0.3
                            c0.5,0.5,0.8,1.3,0.8,2.2c0,1.7-1.2,2.4-2.3,2.4c-1.4,0-2.6-1-4.2-2.7l-0.6-0.6h0v3.5h-0.9V476.3z"/>
                        <path d="M207.7,484.7L207.7,484.7l-0.7-1.4l0.8-0.2l0.9,1.7v0.9h-7.8v-1H207.7z"/>
                    </g>
                    <circle className="st3" cx="78.8" cy="847" r="36.3"/>
                    <ellipse 
                    style={{ fill: this.fillColor("fenderTurnSignal_L")}}
                    onClick={() => this.userClick("fenderTurnSignal_L")}
                    className="st3" cx="158.5" cy="408.3" rx="7.7" ry="14.7"/>
                    <g>
                        <g
                          style={{ fill: this.fillColor("doorUpright_SL")}}>
                            <line className="st5" x1="269.4" y1="640.3" x2="198.1" y2="624.5"/>
                            <polygon points="198,624.7 198.1,624.2 269.4,640.1 269.3,640.6 				"/>
                        </g>
                        <circle 
                          style={{ fill: this.fillColor("doorUpright_SL")}}
                          onClick={() => this.userClick("doorUpright_SL")}
                        className="st6" cx="231.3" cy="617" r="9.7"/>
                    </g>
                    <g>
                        <g
                        style={{ fill: this.fillColor("doorHinge_ZL")}}>
                            <line className="st5" x1="268.2" y1="657.5" x2="197.8" y2="651.1"/>
                            
                                <rect x="232.7" y="618.9" transform="matrix(8.983141e-02 -0.996 0.996 8.983141e-02 -439.5678 827.5549)" width="0.5" height="70.7"/>
                        </g>
                        <circle 
                        style={{ fill: this.fillColor("doorHinge_ZL")}}
                        onClick={() => this.userClick("doorHinge_ZL")}
                        className="st6" cx="233.7" cy="668.3" r="9.7"/>
                    </g>
                    <g>
                        <g style={{ fill: this.fillColor("topDoorSash_ZL")}}>
                            <line className="st5" x1="267.8" y1="657.5" x2="266.5" y2="782.9"/>
                            
                                <rect x="204.4" y="719.9" transform="matrix(1.016705e-02 -0.9999 0.9999 1.016705e-02 -455.6992 980.0108)" width="125.4" height="0.5"/>
                        </g>
                        <circle 
                         style={{ fill: this.fillColor("topDoorSash_ZL")}}
                         onClick={() => this.userClick("topDoorSash_ZL")}
                        className="st6" cx="256.1" cy="724.3" r="9.7"/>
                    </g>
                    <g>
                        <g>
                            <line className="st5" x1="266.5" y1="782.6" x2="200.9" y2="804.3"/>
                            <polygon
                            style={{ fill: this.fillColor("zlDoorStile")}}
                            points="200.8,804.1 266.4,782.4 266.6,782.8 200.9,804.6 				"/>
                        </g>
                        <circle
                         style={{ fill: this.fillColor("zlDoorStile")}}
                         onClick={() => this.userClick("zlDoorStile")}
                        className="st6" cx="235.3" cy="778.9" r="9.7"/>
                    </g>
                    <g>
                        <g
                        style={{ fill: this.fillColor("slidingWindowSlat_ZL")}}>
                            <line className="st5" x1="198.4" y1="651.2" x2="200.9" y2="803.8"/>
                            
                                <rect x="199.4" y="651.2" transform="matrix(0.9999 -1.562309e-02 1.562309e-02 0.9999 -11.3416 3.2076)" width="0.5" height="152.6"/>
                        </g>
                        <circle 
                        style={{ fill: this.fillColor("slidingWindowSlat_ZL")}}
                        onClick={() => this.userClick("slidingWindowSlat_ZL")}
                        className="st6" cx="188.4" cy="727.8" r="9.7"/>
                    </g>
                    <g
                      style={{ fill: this.fillColor("topDoorSash_EN")}}>
                        <path d="M190.2,454.2v-0.5h10.9l0.1,0.1l19.2,30c0.1,0.2,10.7,16.6,22.1,43.9c10.5,25.2,23.7,65.2,27.3,112.3l-0.5,0
                            c-3.6-47.1-16.8-86.9-27.2-112.1c-11.3-27.3-21.9-43.6-22.1-43.8l-19.1-29.8H190.2z"/>
                        <circle 
                          style={{ fill: this.fillColor("topDoorSash_EN")}}
                          onClick={() => this.userClick("topDoorSash_EN")}
                        className="st6" cx="243.3" cy="568.3" r="9.7"/>
                    </g>
                    <g>
                        <g
                        style={{ fill: this.fillColor("slidingWindowTrim_EN")}}>
                            <line x1="197.8" y1="624.5" x2="190.2" y2="454"/>
                            
                                <rect x="193.7" y="453.9" transform="matrix(0.999 -4.487662e-02 4.487662e-02 0.999 -24.0027 9.2486)" width="0.5" height="170.7"/>
                        </g>
                        <circle 
                        style={{ fill: this.fillColor("slidingWindowTrim_EN")}}
                        onClick={() => this.userClick("slidingWindowTrim_EN")}
                        className="st6" cx="179.7" cy="557.2" r="9.7"/>
                    </g>
                    <g>
                        <path d="M227.2,611.9h0.6l0.8,0.8c1.9,2,2.9,2.9,4.1,2.9c0.8,0,1.5-0.4,1.5-1.5c0-0.7-0.4-1.3-0.7-1.7l0.7-0.3
                            c0.5,0.5,0.8,1.3,0.8,2.2c0,1.7-1.2,2.4-2.3,2.4c-1.4,0-2.6-1-4.2-2.7l-0.6-0.6h0v3.5h-0.9V611.9z"/>
                        <path d="M235,623.1h-0.7l-7.1-3.4v-1.1l6.9,3.4h0v-3.8h0.9V623.1z"/>
                    </g>
                    <g>
                        <path d="M239.9,562.9h0.6l0.8,0.8c1.8,1.9,2.7,2.7,3.8,2.7c0.7,0,1.4-0.4,1.4-1.4c0-0.7-0.3-1.2-0.6-1.6l0.7-0.3
                            c0.4,0.5,0.7,1.2,0.7,2.1c0,1.6-1.1,2.2-2.1,2.2c-1.3,0-2.4-1-3.9-2.5l-0.5-0.6h0v3.3h-0.8V562.9z"/>
                        <path d="M246.5,572.8c0-0.2,0-0.5,0-0.7c-0.3-1.6-1.4-2.4-2.6-2.5v0c0.5,0.3,0.8,1,0.8,1.8c0,1.3-0.9,2.2-2.4,2.2
                            c-1.3,0-2.6-0.9-2.6-2.4c0-1.6,1.2-2.6,3.1-2.6c1.4,0,2.6,0.5,3.3,1.2c0.6,0.6,1,1.4,1.1,2.3c0,0.3,0.1,0.5,0.1,0.7H246.5z
                            M242.3,572.6c1,0,1.7-0.6,1.7-1.5c0-0.6-0.4-1.1-0.9-1.4c-0.1-0.1-0.3-0.1-0.4-0.1c-1.2,0-2.1,0.6-2.1,1.6
                            C240.6,572,241.3,572.6,242.3,572.6z"/>
                    </g>
                    <g>
                        <path d="M175.8,552.3h0.6l0.8,0.8c1.8,1.9,2.8,2.8,4,2.8c0.8,0,1.5-0.4,1.5-1.5c0-0.7-0.3-1.3-0.6-1.6l0.7-0.3
                            c0.4,0.5,0.8,1.3,0.8,2.1c0,1.6-1.1,2.3-2.2,2.3c-1.4,0-2.5-1-4.1-2.6l-0.6-0.6h0v3.4h-0.9V552.3z"/>
                        <path d="M182.6,562.8V560l-1.9-0.3c0,0.2,0,0.3,0,0.6c0,0.6-0.1,1.2-0.4,1.6c-0.3,0.6-1,1.1-1.9,1.1c-1.5,0-2.6-1.2-2.6-2.8
                            c0-0.8,0.2-1.5,0.5-1.9l0.8,0.3c-0.2,0.3-0.4,0.9-0.4,1.6c0,1,0.6,1.8,1.6,1.8c1,0,1.7-0.7,1.7-2.2c0-0.4,0-0.8-0.1-1.1l3.6,0.5
                            v3.6H182.6z"/>
                    </g>
                    <g>
                        <path d="M231.5,663c-0.2,0.3-0.5,1-0.5,1.7c0,1.4,0.9,1.8,1.5,1.8c1.1,0,1.6-1,1.6-2v-0.6h0.8v0.6c0,0.8,0.4,1.7,1.3,1.7
                            c0.6,0,1.2-0.4,1.2-1.4c0-0.6-0.3-1.2-0.5-1.6l0.8-0.3c0.3,0.4,0.6,1.2,0.6,2c0,1.5-0.9,2.2-1.9,2.2c-0.8,0-1.5-0.5-1.8-1.4h0
                            c-0.2,1-0.9,1.7-2,1.7c-1.2,0-2.3-1-2.3-2.8c0-0.9,0.3-1.6,0.5-2L231.5,663z"/>
                        <path d="M230.2,668.9h0.6l0.8,0.8c1.9,2,2.9,2.9,4.1,2.9c0.8,0,1.5-0.4,1.5-1.5c0-0.7-0.4-1.3-0.7-1.7l0.7-0.3
                            c0.5,0.5,0.8,1.3,0.8,2.2c0,1.7-1.2,2.4-2.3,2.4c-1.4,0-2.6-1-4.2-2.7l-0.6-0.6h0v3.5h-0.9V668.9z"/>
                    </g>
                    <g>
                        <path d="M253.4,719.7c-0.2,0.3-0.5,1-0.5,1.7c0,1.4,0.9,1.8,1.5,1.8c1.1,0,1.6-1,1.6-2v-0.6h0.8v0.6c0,0.8,0.4,1.7,1.3,1.7
                            c0.6,0,1.2-0.4,1.2-1.4c0-0.6-0.3-1.2-0.5-1.6l0.8-0.3c0.3,0.4,0.6,1.2,0.6,2c0,1.5-0.9,2.2-1.9,2.2c-0.8,0-1.5-0.5-1.8-1.4h0
                            c-0.2,1-0.9,1.7-2,1.7c-1.2,0-2.3-1-2.3-2.8c0-0.9,0.3-1.6,0.5-2L253.4,719.7z"/>
                        <path d="M259,727.9L259,727.9l-0.7-1.4l0.8-0.2l0.9,1.7v0.9h-7.8v-1H259z"/>
                    </g>
                    <g>
                        <path d="M232.6,773.6c-0.2,0.3-0.5,1-0.5,1.7c0,1.4,0.9,1.8,1.5,1.8c1.1,0,1.6-1,1.6-2v-0.6h0.8v0.6c0,0.8,0.4,1.7,1.3,1.7
                            c0.6,0,1.2-0.4,1.2-1.4c0-0.6-0.3-1.2-0.5-1.6l0.8-0.3c0.3,0.4,0.6,1.2,0.6,2c0,1.5-0.9,2.2-1.9,2.2c-0.8,0-1.5-0.5-1.8-1.4h0
                            c-0.2,1-0.9,1.7-2,1.7c-1.2,0-2.3-1-2.3-2.8c0-0.9,0.3-1.6,0.5-2L232.6,773.6z"/>
                        <path d="M232.6,779.7c-0.2,0.3-0.5,1-0.5,1.7c0,1.4,0.9,1.8,1.5,1.8c1.1,0,1.6-1,1.6-2v-0.6h0.8v0.6c0,0.8,0.4,1.7,1.3,1.7
                            c0.6,0,1.2-0.4,1.2-1.4c0-0.6-0.3-1.2-0.5-1.6l0.8-0.3c0.3,0.4,0.6,1.2,0.6,2c0,1.5-0.9,2.2-1.9,2.2c-0.8,0-1.5-0.5-1.8-1.4h0
                            c-0.2,1-0.9,1.7-2,1.7c-1.2,0-2.3-1-2.3-2.8c0-0.9,0.3-1.6,0.5-2L232.6,779.7z"/>
                    </g>
                    <g>
                        <path d="M185.7,723.2c-0.2,0.3-0.5,1-0.5,1.7c0,1.4,0.9,1.8,1.5,1.8c1.1,0,1.6-1,1.6-2v-0.6h0.8v0.6c0,0.8,0.4,1.7,1.3,1.7
                            c0.6,0,1.2-0.4,1.2-1.4c0-0.6-0.3-1.2-0.5-1.6l0.8-0.3c0.3,0.4,0.6,1.2,0.6,2c0,1.5-0.9,2.2-1.9,2.2c-0.8,0-1.5-0.5-1.8-1.4h0
                            c-0.2,1-0.9,1.7-2,1.7c-1.2,0-2.3-1-2.3-2.8c0-0.9,0.3-1.6,0.5-2L185.7,723.2z"/>
                        <path d="M188.4,734.3c-2.7,0-4.1-1-4.1-2.7c0-1.5,1.4-2.6,4-2.6c2.6,0,4.1,1.1,4.1,2.7C192.4,733.4,190.9,734.3,188.4,734.3z
                            M188.3,730.1c-2,0-3.2,0.6-3.2,1.6c0,1.1,1.3,1.6,3.3,1.6c1.9,0,3.2-0.5,3.2-1.6C191.6,730.8,190.5,730.1,188.3,730.1z"/>
                    </g>
                    <path className="st3" d="M71.2,181.5c0,0,9.1,4.1,18.3,0v12.3c0,0-6.7,6.9-18.3,3.4V181.5z"/>
                    <path d="M710.9,453.3"/>
                    <g>
                        <line className="st2" x1="842.4" y1="265.8" x2="842.4" y2="404"/>
                        <circle className="st3" cx="832.6" cy="335.7" r="59.3"/>
                        <circle className="st3" cx="831.6" cy="334.7" r="36.3"/>
                    </g>
                    <path className="st4" d="M712.1,377.1L642,516.3c0,0-12.2,37.8-17.2,78.7c-5,41-3.8,206.4-1.6,206.5c0,0,8,24.2,9.8,29.8
                        s68.5,155.5,68.5,155.5s-3.8,25.6,7.6,29.8s61,0,61,0l9.7,12.5l33.7,1.3c0,0,8.2-4.8,14-10.7h11l4.5-104.9c0,0-83.2,4.6-80.2-68.7
                        s85-70.7,89.7-70.3c4.7,0.3,0-372.7,0-372.7s-87,12.8-91-70c0,0,7.8-78.5,93.1-66v-5.8l-5.1-0.3l2-39.3
                        c0.1,0.2-6.4-40.8-12.3-38.8c-17.1,6-23.8-4.5-24.4-7.1h-29l-5.7,5.5l-24.9,13.9c0,0-12.6,10.5-13.4,17.6
                        C740.9,219.8,719.6,249.9,712.1,377.1z"/>
                    <line className="st2" x1="842.4" y1="776" x2="842.4" y2="914.2"/>
                    <circle className="st3" cx="832.6" cy="848" r="59.3"/>
                    <path className="st4" d="M635.2,648.5l0.2,141.6l74.8,28.3c0,0,35.6,15.4,58.9-17c23.8-33.2,68-31.7,68-31.7l1.3-135.7
                        C838.4,634,784.2,620.5,635.2,648.5z"/>
                    <ellipse className="st1" cx="751.2" cy="408.5" rx="5.1" ry="13.5"/>
                    <ellipse className="st3" cx="729.9" cy="920.7" rx="13" ry="18.8"/>
                    <path className="st4" d="M727.9,430.8c0,0-16.8,11.6-28,25.9c-10.7,13.6-44.2,74.8-57,126.3c-11.8,47.4-8.2,66.8-8.2,66.8
                        c-3.5-0.7,152.9-27.7,203.7-15.8l1.1-187.7c0,0,1.8-16.3-21.9-15.5C793.9,431.6,727.9,430.8,727.9,430.8z"/>
                    <path className="st4" d="M776.3,221.8c0,0-20.9,0.2-27.9,23.7c-7.5,25-21.5,123-21.5,123s-5.9,26.7-12.9,35.8l-1.7-28.6
                        c0,0,1.7,3,0.2,0.7C709.7,372,725.2,219,751.2,199c13.5-10.4,28.9-17.4,28.9-17.4"/>
                    <path className="st4" d="M776.3,221.8l1.3,71.5c0,0,21.3-35.8,77.1-26.3v-5.8l-5.1-0.3l2-39.3c-1.1,0.3-4.7-34.8-11.9-38.9
                        c0,0-16,8-24.8-6.9h-29l-5.3,5.7L776.3,221.8z"/>
                    <polyline 
                    style={{ fill: this.fillColor("doorTrimLower_SD")}}
                    onClick={() => this.userClick("doorTrimLower_SD")}
                    className="st3" points="828.4,448.6 820.4,448.6 820.4,455.1 818.5,459.6 818.5,596.6 820.4,599 820.5,605.8 826.7,605.8 
                        826.7,598.6 830,595 830,458 828,457 828.4,449.5 		"/>
                    <polyline 
                    style={{ fill: this.fillColor("sdDoorTrimBelow")}}
                    onClick={() => this.userClick("sdDoorTrimBelow")}
                    className="st3" points="830.4,645 822.4,645 822.4,649.8 820.5,653.2 820.5,756.1 822.4,757.8 822.5,763 828.7,763 
                        828.7,757.6 832,754.8 832,652 830,651.2 830.4,645.6 		"/>
                    <polygon 
                     style={{ fill: this.fillColor("mirrorOutside_D")}}
                     onClick={() => this.userClick("mirrorOutside_D")}
                    className="st3" points="720.2,454 709.5,454 690.4,483.6 691.4,500.8 705.4,500 718.5,483 		"/>
                    <polygon 
                    style={{ fill: this.fillColor("turnSignalOnOutsideMirror_D")}}
                    onClick={() => this.userClick("turnSignalOnOutsideMirror_D")}
                    className="st3" points="718.5,483.2 705.6,499.8 706.3,505.7 711.1,506.2 717.9,498.3 		"/>
                    <path 
                     style={{ fill: this.fillColor("doorHandle_SD")}}
                     onClick={() => this.userClick("doorHandle_SD")}
                    className="st3" d="M741,614.7v-22.2c0-3.4-2.7-6.1-6.1-6.1l0,0c-3.4,0-6.1,2.7-6.1,6.1v22.2c0,3.4,2.7,6.1,6.1,6.1l0,0
                        C738.3,620.8,741,618.1,741,614.7z"/>
                    <path 
                    style={{ fill: this.fillColor("sdDoorHandle")}}
                    onClick={() => this.userClick("sdDoorHandle")}
                    className="st3" d="M741,810.1V788c0-3.4-2.7-6.1-6.1-6.1l0,0c-3.4,0-6.1,2.7-6.1,6.1v22.2c0,3.4,2.7,6.1,6.1,6.1l0,0
                        C738.3,816.2,741,813.5,741,810.1z"/>
                    <path 
                     style={{ fill: this.fillColor("windowTriangle_ZD")}}
                     onClick={() => this.userClick("windowTriangle_ZD")}
                    className="st3" d="M643.2,799l66.3,26V876c0,0-7.9,23.5-28.7-7.8S643.2,799,643.2,799z"/>
                    <path 
                     style={{ fill: this.fillColor("brakeLightExternal_D")}}
                     onClick={() => this.userClick("brakeLightExternal_D")}
                    className="st3" d="M750.3,1017.1c0,0-1.8-23-1.8-28.9c0-5.9-6.3-6.6-6.3-6.6s-14.3,0-21,0s-6,6.6-6,6.6v27.7l0,1.8
                        c0,0,26.3,1.3,35,0V1017.1z"/>
                    <path className="st4" d="M771.9,884.4l-3.7,15.5l2,116.5l9.7,12.5l34.1,1.6l14-10.7l10.6-0.3l5.2-105.4
                        C843.5,914.1,793.7,918.8,771.9,884.4z"/>
                    <path className="st4" d="M642,516.3c0,0,5.8,16.5,7.8,20.7c2,4.2,62.7-116.7,62.7-116.7c2.2-6,0.9-43.5,0.1-43.9L642,516.3z"/>
                    <path className="st4" d="M649.8,537c0,0-10.3,36.6-15.5,70c-5.3,33.4-3.1,173.5-2.1,180s6.6,38.7,10.5,47.5c3.6,8.2,60,119,60,119
                        s8,14.8-1,33.3l-62-140.3c0,0-11.1-25.9-16.3-45c-5.3-19.6-0.9-213,2.2-213c0,0,9.3-57.8,16.7-71.6L649.8,537z"/>
                    <circle className="st3" cx="831.6" cy="847" r="36.3"/>
                    <ellipse 
                     style={{ fill: this.fillColor("fenderTurnSignal_D")}}
                     onClick={() => this.userClick("fenderTurnSignal_D")}
                    className="st3" cx="751.9" cy="408.3" rx="7.7" ry="14.7"/>
                    <g>
                        <g  style={{ fill: this.fillColor("doorStile_SD")}}>
                            <line className="st5" x1="641" y1="640.3" x2="712.3" y2="624.5"/>
                            <rect x="640.1" y="632.2" transform="matrix(0.9761 -0.2174 0.2174 0.9761 -121.3069 162.2414)" width="73" height="0.5"/>
                        </g>
                        <circle 
                         style={{ fill: this.fillColor("doorStile_SD")}}
                         onClick={() => this.userClick("doorStile_SD")}
                        className="st6" cx="679.1" cy="617" r="9.7"/>
                    </g>
                    <g>
                        <g style={{ fill: this.fillColor("zdDoorUpStand")}}>
                            <line className="st5" x1="642.2" y1="657.5" x2="712.6" y2="651.1"/>
                            <rect x="642" y="654" transform="matrix(0.996 -8.983141e-02 8.983141e-02 0.996 -56.036 63.4957)" width="70.7" height="0.5"/>
                        </g>
                        <circle 
                        style={{ fill: this.fillColor("zdDoorUpStand")}}
                        onClick={() => this.userClick("zdDoorUpStand")}
                        className="st6" cx="676.7" cy="668.3" r="9.7"/>
                    </g>
                    <g>
                        <g style={{ fill: this.fillColor("upperDoorLeaf_ZD")}}>
                            <line className="st5" x1="642.6" y1="657.5" x2="643.9" y2="782.9"/>
                            
                                <rect x="643" y="657.5" transform="matrix(0.9999 -1.016705e-02 1.016705e-02 0.9999 -7.2889 6.5768)" width="0.5" height="125.4"/>
                        </g>
                        <circle 
                        style={{ fill: this.fillColor("upperDoorLeaf_ZD")}}
                        onClick={() => this.userClick("upperDoorLeaf_ZD")}
                        className="st6" cx="657.3" cy="724.3" r="9.7"/>
                    </g>
                    <g>
                        <g>
                            <line className="st5" x1="643.9" y1="782.6" x2="709.5" y2="804.3"/>
                            <polygon  style={{ fill: this.fillColor("zdDoorStile")}} points="709.6,804.1 643.9,782.4 643.8,782.8 709.4,804.6 				"/>
                        </g>
                        <circle 
                        style={{ fill: this.fillColor("zdDoorStile")}}
                        onClick={() => this.userClick("zdDoorStile")}
                        className="st6" cx="675.1" cy="778.9" r="9.7"/>
                    </g>
                    <g>
                        <g  style={{ fill: this.fillColor("slidingWindowMoulding_ZD")}}>
                            <line className="st5" x1="712" y1="651.2" x2="709.5" y2="803.8"/>
                            
                                <rect x="634.5" y="727.3" transform="matrix(1.562309e-02 -0.9999 0.9999 1.562309e-02 -27.7789 1426.8108)" width="152.6" height="0.5"/>
                        </g>
                        <circle 
                         style={{ fill: this.fillColor("slidingWindowMoulding_ZD")}}
                         onClick={() => this.userClick("slidingWindowMoulding_ZD")}
                        className="st6" cx="724" cy="727.8" r="9.7"/>
                    </g>
                    <g   style={{ fill: this.fillColor("doorTrimAbove_SD")}}>
                        <path d="M720.2,454.2v-0.5h-10.9l-0.1,0.1l-19.2,30c-0.1,0.2-10.7,16.6-22.1,43.9c-10.5,25.2-23.7,65.2-27.3,112.3l0.5,0
                            c3.6-47.1,16.8-86.9,27.2-112.1c11.3-27.3,21.9-43.6,22.1-43.8l19.1-29.8H720.2z"/>
                        <circle 
                          style={{ fill: this.fillColor("doorTrimAbove_SD")}}
                          onClick={() => this.userClick("doorTrimAbove_SD")}
                        className="st6" cx="667.1" cy="568.3" r="9.7"/>
                    </g>
                    <g>
                        <g style={{ fill: this.fillColor("slidingWindowTrim_SD")}}>
                            <line x1="712.6" y1="624.5" x2="720.2" y2="454"/>
                            
                                <rect x="631.1" y="539" transform="matrix(4.487662e-02 -0.999 0.999 4.487662e-02 145.5746 1230.6903)" width="170.7" height="0.5"/>
                        </g>
                        <circle 
                         style={{ fill: this.fillColor("slidingWindowTrim_SD")}}
                         onClick={() => this.userClick("slidingWindowTrim_SD")}
                        className="st6" cx="728.7" cy="557.2" r="9.7"/>
                    </g>
                    <path className="st3" d="M839.2,181.5c0,0-9.1,4.1-18.3,0v12.3c0,0,6.7,6.9,18.3,3.4V181.5z"/>
                    <g>
                        <path d="M766.4,403.8c-0.2,0.3-0.5,1-0.5,1.7c0,1.4,0.9,1.8,1.5,1.8c1.1,0,1.6-1,1.6-2v-0.6h0.8v0.6c0,0.8,0.4,1.7,1.3,1.7
                            c0.6,0,1.2-0.4,1.2-1.4c0-0.6-0.3-1.2-0.5-1.6l0.8-0.3c0.3,0.4,0.6,1.2,0.6,2c0,1.5-0.9,2.2-1.9,2.2c-0.8,0-1.5-0.5-1.8-1.4h0
                            c-0.2,1-0.9,1.7-2,1.7c-1.2,0-2.3-1-2.3-2.8c0-0.9,0.3-1.6,0.5-2L766.4,403.8z"/>
                        <path d="M773,414.7h-0.7l-7.1-3.4v-1.1l6.9,3.4h0v-3.8h0.9V414.7z"/>
                    </g>
                    <g>
                        <path d="M703.5,474c-0.2,0.3-0.5,1-0.5,1.7c0,1.4,0.9,1.8,1.5,1.8c1.1,0,1.6-1,1.6-2v-0.6h0.8v0.6c0,0.8,0.4,1.7,1.3,1.7
                            c0.6,0,1.2-0.4,1.2-1.4c0-0.6-0.3-1.2-0.5-1.6l0.8-0.3c0.3,0.4,0.6,1.2,0.6,2c0,1.5-0.9,2.2-1.9,2.2c-0.8,0-1.5-0.5-1.8-1.4h0
                            c-0.2,1-0.9,1.7-2,1.7c-1.2,0-2.3-1-2.3-2.8c0-0.9,0.3-1.6,0.5-2L703.5,474z"/>
                        <path d="M704.3,479.8c1,0,1.7,0.6,2.1,1.5l0,0c0.4-0.9,1.1-1.2,1.8-1.2c1.2,0,2.1,1,2.1,2.4c0,1.5-0.9,2.3-1.9,2.3
                            c-0.7,0-1.4-0.3-1.8-1.3h0c-0.4,1-1.1,1.6-2,1.6c-1.4,0-2.3-1.2-2.3-2.7C702.2,480.8,703.1,479.8,704.3,479.8z M704.3,484
                            c0.9,0,1.4-0.7,1.7-1.7c-0.3-0.9-0.9-1.4-1.6-1.4c-0.8,0-1.5,0.6-1.5,1.6C702.9,483.4,703.5,484,704.3,484z M708.2,481.1
                            c-0.8,0-1.2,0.6-1.4,1.5c0.2,0.7,0.7,1.2,1.4,1.2c0.6,0,1.3-0.4,1.3-1.3C709.5,481.6,708.9,481.1,708.2,481.1z"/>
                    </g>
                    <g>
                        <path d="M725.2,487.3c-0.2,0.3-0.5,1-0.5,1.7c0,1.4,0.9,1.8,1.5,1.8c1.1,0,1.6-1,1.6-2v-0.6h0.8v0.6c0,0.8,0.4,1.7,1.3,1.7
                            c0.6,0,1.2-0.4,1.2-1.4c0-0.6-0.3-1.2-0.5-1.6l0.8-0.3c0.3,0.4,0.6,1.2,0.6,2c0,1.5-0.9,2.2-1.9,2.2c-0.8,0-1.5-0.5-1.8-1.4h0
                            c-0.2,1-0.9,1.7-2,1.7c-1.2,0-2.3-1-2.3-2.8c0-0.9,0.3-1.6,0.5-2L725.2,487.3z"/>
                        <path d="M724.8,493.9c0,0.2,0,0.5,0,0.9c0.1,0.6,0.3,1.2,0.8,1.6c0.5,0.5,1.2,0.9,2.1,1v0c-0.5-0.4-0.8-1.1-0.8-1.8
                            c0-1.4,1.1-2.3,2.4-2.3c1.5,0,2.8,1.1,2.8,2.7s-1.3,2.6-3.3,2.6c-1.7,0-2.9-0.6-3.7-1.3c-0.6-0.6-0.9-1.4-1-2.3
                            c-0.1-0.4-0.1-0.7-0.1-1H724.8z M729.2,494.2c-1,0-1.7,0.6-1.7,1.5c0,0.7,0.3,1.3,0.8,1.5c0.1,0.1,0.2,0.1,0.4,0.1
                            c1.3,0,2.4-0.5,2.4-1.6C731.1,494.9,730.3,494.2,729.2,494.2z"/>
                    </g>
                    <g>
                        <path d="M746.1,600h2.1v-3.6h0.7l5,3.5v1.1h-4.8v1.1h-0.8V601h-2.1V600z M749.1,600h2.6c0.4,0,0.8,0,1.2,0v0
                            c-0.5-0.2-0.8-0.4-1.2-0.6l-2.7-1.9h0V600z"/>
                        <path d="M750.1,608.1c-2.7,0-4.1-1-4.1-2.7c0-1.5,1.4-2.6,4-2.6c2.6,0,4.1,1.1,4.1,2.7C754.1,607.2,752.6,608.1,750.1,608.1z
                            M750,603.9c-2,0-3.2,0.6-3.2,1.6c0,1.1,1.3,1.6,3.3,1.6c1.9,0,3.2-0.5,3.2-1.6C753.3,604.6,752.1,603.9,750,603.9z"/>
                    </g>
                    <g>
                        <path d="M726.1,555.1h1.9v-3.2h0.6l4.4,3.1v1h-4.3v1H728v-1h-1.9V555.1z M728.7,555.1h2.3c0.4,0,0.7,0,1.1,0v0
                            c-0.4-0.2-0.7-0.4-1-0.6l-2.3-1.7h0V555.1z"/>
                        <path d="M726.1,557.6h0.6l0.7,0.7c1.7,1.8,2.6,2.6,3.6,2.6c0.7,0,1.3-0.3,1.3-1.4c0-0.6-0.3-1.1-0.6-1.5l0.7-0.3
                            c0.4,0.5,0.7,1.2,0.7,2c0,1.5-1,2.1-2,2.1c-1.3,0-2.3-0.9-3.7-2.4l-0.5-0.6h0v3.1h-0.8V557.6z"/>
                    </g>
                    <g>
                        <path d="M675.7,615.3h1.9v-3.2h0.6l4.4,3.1v1h-4.3v1h-0.7v-1h-1.9V615.3z M678.3,615.3h2.3c0.4,0,0.7,0,1.1,0v0
                            c-0.4-0.2-0.7-0.4-1-0.6l-2.3-1.7h0V615.3z"/>
                        <path d="M675.7,620.7h1.9v-3.2h0.6l4.4,3.1v1h-4.3v1h-0.7v-1h-1.9V620.7z M678.3,620.7h2.3c0.4,0,0.7,0,1.1,0v0
                            c-0.4-0.2-0.7-0.4-1-0.6l-2.3-1.7h0V620.7z"/>
                    </g>
                    <g>
                        <path d="M663.4,566.3h1.9v-3.2h0.6l4.4,3.1v1H666v1h-0.7v-1h-1.9V566.3z M666,566.3h2.3c0.4,0,0.7,0,1.1,0v0
                            c-0.4-0.2-0.7-0.4-1-0.6L666,564h0V566.3z"/>
                        <path d="M664.5,569.1c-0.2,0.3-0.4,0.9-0.4,1.5c0,1.2,0.8,1.6,1.3,1.6c1,0,1.4-0.9,1.4-1.8v-0.5h0.7v0.5c0,0.7,0.3,1.5,1.2,1.5
                            c0.6,0,1-0.4,1-1.2c0-0.6-0.2-1.1-0.5-1.4l0.7-0.2c0.3,0.4,0.5,1.1,0.5,1.8c0,1.4-0.8,2-1.6,2c-0.7,0-1.3-0.4-1.6-1.3h0
                            c-0.2,0.8-0.8,1.5-1.8,1.5c-1.1,0-2.1-0.9-2.1-2.5c0-0.8,0.2-1.5,0.5-1.8L664.5,569.1z"/>
                    </g>
                    <g>
                        <path d="M673.2,666.5h1.9v-3.2h0.6l4.4,3.1v1h-4.3v1h-0.7v-1h-1.9V666.5z M675.8,666.5h2.3c0.4,0,0.7,0,1.1,0v0
                            c-0.4-0.2-0.7-0.4-1-0.6l-2.3-1.7h0V666.5z"/>
                        <path d="M673.9,669.6c0,0.2,0,0.4,0,0.8c0.1,0.5,0.3,1,0.7,1.4c0.4,0.5,1,0.8,1.8,0.9v0c-0.5-0.4-0.7-0.9-0.7-1.6
                            c0-1.2,0.9-2,2.1-2c1.3,0,2.4,0.9,2.4,2.4s-1.1,2.3-2.9,2.3c-1.5,0-2.6-0.5-3.2-1.2c-0.5-0.5-0.8-1.3-0.9-2
                            c-0.1-0.3-0.1-0.6-0.1-0.9H673.9z M677.9,669.9c-0.9,0-1.5,0.5-1.5,1.3c0,0.6,0.3,1.1,0.7,1.4c0.1,0.1,0.2,0.1,0.3,0.1
                            c1.2,0,2.1-0.4,2.1-1.4C679.5,670.5,678.8,669.9,677.9,669.9z"/>
                    </g>
                    <g>
                        <path d="M720.4,726.3h1.9v-3.2h0.6l4.4,3.1v1H723v1h-0.7v-1h-1.9V726.3z M723,726.3h2.3c0.4,0,0.7,0,1.1,0v0
                            c-0.4-0.2-0.7-0.4-1-0.6l-2.3-1.7h0V726.3z"/>
                        <path d="M727.3,733.3h-0.6l-6.3-3v-1l6.1,3h0V729h0.8V733.3z"/>
                    </g>
                    <g>
                        <path d="M654.4,721.9h1.9v-3.2h0.6l4.4,3.1v1H657v1h-0.7v-1h-1.9V721.9z M657,721.9h2.3c0.4,0,0.7,0,1.1,0v0
                            c-0.4-0.2-0.7-0.4-1-0.6l-2.3-1.7h0V721.9z"/>
                        <path d="M656.1,724.4c0.9,0,1.5,0.5,1.8,1.4l0,0c0.4-0.8,1-1.1,1.5-1.1c1.1,0,1.8,0.9,1.8,2.1c0,1.3-0.8,2-1.7,2
                            c-0.6,0-1.2-0.3-1.6-1.1h0c-0.3,0.9-0.9,1.4-1.8,1.4c-1.2,0-2-1-2-2.3C654.3,725.3,655.1,724.4,656.1,724.4z M656.2,728.1
                            c0.8,0,1.2-0.6,1.5-1.5c-0.2-0.8-0.8-1.2-1.4-1.2c-0.7,0-1.3,0.5-1.3,1.4C655,727.6,655.5,728.1,656.2,728.1z M659.6,725.6
                            c-0.7,0-1.1,0.5-1.3,1.3c0.2,0.6,0.6,1,1.3,1c0.6,0,1.1-0.3,1.1-1.2C660.7,726,660.2,725.6,659.6,725.6z"/>
                    </g>
                    <g>
                        <path d="M678.1,778v-2.6l-1.8-0.3c0,0.2,0,0.3,0,0.6c0,0.5-0.1,1.1-0.4,1.5c-0.3,0.5-0.9,1-1.8,1c-1.3,0-2.4-1.1-2.4-2.6
                            c0-0.8,0.2-1.4,0.4-1.7l0.7,0.2c-0.2,0.3-0.4,0.8-0.4,1.5c0,0.9,0.6,1.6,1.5,1.6c0.9,0,1.5-0.6,1.5-2c0-0.4,0-0.7-0.1-1l3.3,0.4
                            v3.3H678.1z"/>
                        <path d="M675.5,783.9c-2.3,0-3.6-0.9-3.6-2.4c0-1.3,1.3-2.3,3.5-2.3c2.3,0,3.6,1,3.6,2.4C679,783.1,677.7,783.9,675.5,783.9z
                            M675.4,780.2c-1.8,0-2.8,0.6-2.8,1.4c0,1,1.1,1.4,2.9,1.4c1.7,0,2.8-0.4,2.8-1.4C678.3,780.8,677.3,780.2,675.4,780.2z"/>
                    </g>
                    <g>
                        <path d="M746.1,795.3h2.1v-3.6h0.7l5,3.5v1.1h-4.8v1.1h-0.8v-1.1h-2.1V795.3z M749.1,795.3h2.6c0.4,0,0.8,0,1.2,0v0
                            c-0.5-0.2-0.8-0.4-1.2-0.6l-2.7-1.9h0V795.3z"/>
                        <path d="M753,802.8v-3l-2-0.3c0,0.2,0,0.3,0,0.6c0,0.6-0.1,1.2-0.4,1.7c-0.3,0.6-1,1.1-2,1.1c-1.5,0-2.7-1.2-2.7-2.9
                            c0-0.9,0.2-1.6,0.5-1.9l0.8,0.3c-0.2,0.3-0.4,1-0.4,1.7c0,1,0.6,1.8,1.7,1.8c1,0,1.7-0.7,1.7-2.2c0-0.4,0-0.8-0.1-1.1l3.7,0.5
                            v3.7H753z"/>
                    </g>
                    <g>
                        <path d="M723.8,852.2v-3l-2-0.3c0,0.2,0,0.3,0,0.6c0,0.6-0.1,1.2-0.4,1.7c-0.3,0.6-1,1.1-2,1.1c-1.5,0-2.7-1.2-2.7-2.9
                            c0-0.9,0.2-1.6,0.5-1.9l0.8,0.3c-0.2,0.3-0.4,1-0.4,1.7c0,1,0.6,1.8,1.7,1.8c1,0,1.7-0.7,1.7-2.2c0-0.4,0-0.8-0.1-1.1l3.7,0.5
                            v3.7H723.8z"/>
                        <path d="M723.7,856L723.7,856l-0.7-1.4l0.8-0.2l0.9,1.7v0.9h-7.8v-1H723.7z"/>
                    </g>
                    <g>
                        <path d="M734.8,999.2v-3l-2-0.3c0,0.2,0,0.3,0,0.6c0,0.6-0.1,1.2-0.4,1.7c-0.3,0.6-1,1.1-2,1.1c-1.5,0-2.7-1.2-2.7-2.9
                            c0-0.9,0.2-1.6,0.5-1.9l0.8,0.3c-0.2,0.3-0.4,1-0.4,1.7c0,1,0.6,1.8,1.7,1.8c1,0,1.7-0.7,1.7-2.2c0-0.4,0-0.8-0.1-1.1l3.7,0.5
                            v3.7H734.8z"/>
                        <path d="M727.9,1000.7h0.6l0.8,0.8c1.9,2,2.9,2.9,4.1,2.9c0.8,0,1.5-0.4,1.5-1.5c0-0.7-0.4-1.3-0.7-1.7l0.7-0.3
                            c0.5,0.5,0.8,1.3,0.8,2.2c0,1.7-1.2,2.4-2.3,2.4c-1.4,0-2.6-1-4.2-2.7l-0.6-0.6h0v3.5h-0.9V1000.7z"/>
                    </g>
                    <g>
                        <path d="M801.4,531h2.1v-3.6h0.7l5,3.5v1.1h-4.8v1.1h-0.8V532h-2.1V531z M804.3,531h2.6c0.4,0,0.8,0,1.2,0v0
                            c-0.5-0.2-0.8-0.4-1.2-0.6l-2.7-1.9h0V531z"/>
                        <path d="M808.2,536.2L808.2,536.2l-0.7-1.4l0.8-0.2l0.9,1.7v0.9h-7.8v-1H808.2z"/>
                    </g>
                    <g>
                        <path d="M801.4,704h2.1v-3.6h0.7l5,3.5v1.1h-4.8v1.1h-0.8V705h-2.1V704z M804.3,704h2.6c0.4,0,0.8,0,1.2,0v0
                            c-0.5-0.2-0.8-0.4-1.2-0.6l-2.7-1.9h0V704z"/>
                        <path d="M808.4,711.4c0-0.2,0-0.5,0-0.8c-0.3-1.7-1.5-2.5-2.8-2.7v0c0.5,0.4,0.9,1,0.9,1.9c0,1.4-1,2.4-2.5,2.4
                            c-1.4,0-2.7-1-2.7-2.6c0-1.7,1.3-2.8,3.3-2.8c1.5,0,2.7,0.6,3.5,1.3c0.6,0.6,1,1.5,1.2,2.5c0,0.3,0.1,0.6,0.1,0.8H808.4z
                            M803.9,711.1c1.1,0,1.8-0.6,1.8-1.6c0-0.6-0.4-1.2-1-1.5c-0.1-0.1-0.3-0.1-0.5-0.1c-1.3,0-2.2,0.6-2.2,1.7
                            C802,710.4,802.8,711.1,803.9,711.1z"/>
                    </g>
                    <path 
                     style={{ fill: this.fillColor("windscreen")}}
                     onClick={() => this.userClick("windscreen")}
                    className="st4" d="M598.5,393.5l-25.7,115.7c0,0-1.3,2-15.7,2c-14.3,0-86-19.3-228.5,0l-29.8-117.7H598.5"/>
                    <g>
                        <path d="M448.5,471.2L448.5,471.2l-0.7-1.4l0.8-0.2l0.9,1.7v0.9h-7.8v-1H448.5z"/>
                        <path d="M448.5,477.4L448.5,477.4l-0.7-1.4l0.8-0.2l0.9,1.7v0.9h-7.8v-1H448.5z"/>
                    </g>
                    <g>
                        <path 
                         style={{ fill: this.fillColor("frontWiperLCover")}}
                         onClick={() => this.userClick("frontWiperLCover")}
                        className="st3" d="M440.3,402.1c0,0,5.1,3,0,8.3l-107-1.1V403L440.3,402.1z"/>
                        <rect 
                         style={{ fill: this.fillColor("frontWiperLCover")}}
                         onClick={() => this.userClick("frontWiperLCover")}
                        x="318.9" y="399.1" className="st3" width="14.5" height="14.8"/>
                    </g>
                    <g>
                        <path 
                          style={{ fill: this.fillColor("frontWiperDCover")}}
                          onClick={() => this.userClick("frontWiperDCover")}
                        className="st3" d="M579.8,400.3c0,0,4.6,3,0,8.3l-96.5-1.1v-6.3L579.8,400.3z"/>
                        <rect 
                          style={{ fill: this.fillColor("frontWiperDCover")}}
                          onClick={() => this.userClick("frontWiperDCover")}
                        x="468.8" y="397.3" className="st3" width="14.5" height="14.8"/>
                    </g>
                    <path className="st4" d="M598.6,393.3l5.7-5.2c0,0-1.3-188.8-22-195.8s-73.3-18-79.7-18s-6.3,0-6.3,0v3.4l-13.3,0.1v-3.3l-65.8-0.4
                        l-1.8,2.4l-11.3,0.8l-5-3c0,0-81,5.1-92.8,32.1s-12,159.7-12,159.7s-3.5,15.5,4.2,25.3c7.7,9.8,2.9-42.7,134.3-38.7l3.5-2.3h10.3
                        l2.6,2.6l2.5-2.8l10-0.1l1.1,3C462.9,353,554.4,339.8,598.6,393.3z"/>
                    <path 
                     style={{ fill: this.fillColor("pvcLiningUnderVS_L")}}
                     onClick={() => this.userClick("pvcLiningUnderVS_L")}
                    className="st3" d="M299,393.3h152l0.8-43.1C451.8,350.2,332.3,342.3,299,393.3z"/>
                    <path 
                     style={{ fill: this.fillColor("pvcLiningUnderVS_D")}}
                     onClick={() => this.userClick("pvcLiningUnderVS_D")}
                    className="st3" d="M451,393.3h147.6c0,0-22.7-53.9-146.8-43.1L451,393.3z"/>
                    <path className="st7" d="M481.4,398.6"/>
                    <g>
                        <circle 
                        style={{ fill: this.fillColor("emblem")}}
                        onClick={() => this.userClick("emblem")}
                        className="st8" cx="453.1" cy="194.4" r="13.4"/>
                        <g>
                            <path d="M456.2,196.8c0-0.2,0-0.5,0-0.8c-0.3-1.7-1.5-2.5-2.8-2.7v0c0.5,0.4,0.9,1,0.9,1.9c0,1.4-1,2.4-2.5,2.4
                                c-1.4,0-2.7-1-2.7-2.6c0-1.7,1.3-2.8,3.3-2.8c1.5,0,2.7,0.6,3.5,1.3c0.6,0.6,1,1.5,1.2,2.5c0,0.3,0.1,0.6,0.1,0.8H456.2z
                                M451.7,196.5c1.1,0,1.8-0.6,1.8-1.6c0-0.6-0.4-1.2-1-1.5c-0.1-0.1-0.3-0.1-0.5-0.1c-1.3,0-2.2,0.6-2.2,1.7
                                C449.8,195.9,450.6,196.5,451.7,196.5z"/>
                        </g>
                    </g>
                    <g>
                        <path d="M500.6,369.1c1,0,1.7,0.6,2.1,1.5l0,0c0.4-0.9,1.1-1.2,1.8-1.2c1.2,0,2.1,1,2.1,2.4c0,1.5-0.9,2.3-1.9,2.3
                            c-0.7,0-1.4-0.3-1.8-1.3h0c-0.4,1-1.1,1.6-2,1.6c-1.4,0-2.3-1.2-2.3-2.7C498.5,370,499.5,369.1,500.6,369.1z M500.7,373.3
                            c0.9,0,1.4-0.7,1.7-1.7c-0.3-0.9-0.9-1.4-1.6-1.4c-0.8,0-1.5,0.6-1.5,1.6C499.3,372.7,499.9,373.3,500.7,373.3z M504.6,370.4
                            c-0.8,0-1.2,0.6-1.4,1.5c0.2,0.7,0.7,1.2,1.4,1.2c0.6,0,1.3-0.4,1.3-1.3C505.8,370.8,505.2,370.4,504.6,370.4z"/>
                    </g>
                    <g>
                        <path d="M402.7,375.2H402l-7.1-3.4v-1.1l6.9,3.4h0v-3.8h0.9V375.2z"/>
                    </g>
                    <path className="st4" d="M399.3,174.2L293.7,176l3.9-34.7l-15,1.7c0,0,0.7-27,8.3-45.7c0,0-6.3-25.7,17.7-24s288.7-0.1,288.7-0.1
                        s12,1.1,10.7,14.7c-1.3,13.7,0.1,11.3,0.1,11.3s12.9,36.3,7.6,43.3l-13.3,3l4,27.9L399.3,174.2z"/>
                    <path className="st3" d="M574.3,94l-248.2,1c0,0-17.5,15.3,0,18c17.5,2.7,244.8,2,244.8,2s11.7,2.3,8.2-9S574.3,94,574.3,94z"/>
                    <path className="st3" d="M502.7,115v14.7c0,0,1.2,4.9-5.1,5.3c-6.3,0.3-98.2-1.2-98.2-1.2s-5.7,0.2-5.4-6.5c0.3-6.6,0-12.7,0-12.7
                        L502.7,115z"/>
                    <g>
                        <g>
                            <circle 
                             style={{ fill: this.fillColor("foggy_L")}}
                             onClick={() => this.userClick("foggy_L")}
                            className="st1" cx="305" cy="121.7" r="11.2"/>
                            <path d="M293.5,121.7c0-6.3,5.2-11.5,11.5-11.5s11.5,5.2,11.5,11.5c0,6.3-5.2,11.5-11.5,11.5S293.5,128.1,293.5,121.7z
                                M316,121.7c0-6.1-4.9-11-11-11c-6.1,0-11,4.9-11,11c0,6.1,4.9,11,11,11C311,132.7,316,127.8,316,121.7z"/>
                        </g>
                        <g>
                            <path className="st9" d="M308.4,121.4L308.4,121.4l-0.7-1.4l0.8-0.2l0.9,1.7v0.9h-7.8v-1H308.4z"/>
                        </g>
                    </g>
                    <g>
                        <circle 
                         style={{ fill: this.fillColor("meglena_D")}}
                         onClick={() => this.userClick("meglena_D")}
                        className="st8" cx="594.1" cy="121.7" r="11.2"/>
                        <g>
                            <path d="M590.8,119.1h0.6l0.8,0.8c1.9,2,2.9,2.9,4.1,2.9c0.8,0,1.5-0.4,1.5-1.5c0-0.7-0.4-1.3-0.7-1.7l0.7-0.3
                                c0.5,0.5,0.8,1.3,0.8,2.2c0,1.7-1.2,2.4-2.3,2.4c-1.4,0-2.6-1-4.2-2.7l-0.6-0.6h0v3.5h-0.9V119.1z"/>
                        </g>
                    </g>
                    <path 
                    style={{ fill: this.fillColor("ventilationGrille")}}
                    onClick={() => this.userClick("ventilationGrille")}
                    className="st3" d="M536.1,173.6c0,0-20.4-18.4-15.3-32.6h73.8c0,0,5.6,0.1,7.2,5.5c0.1,0.5,0.3,1.2,0.4,1.9
                        c0.1,0.8,0.3,1.7,0.4,2.7c0,0,0,0,0,0.1l0,0.2c0.5,2.6,4.1,21.9,3.5,22.5h-3.4h-0.7L536.1,173.6z"/>
                    <path 
                      style={{ fill: this.fillColor("headlamp_L")}}
                      onClick={() => this.userClick("headlamp_L")}
                    className="st3" d="M362.2,174.8c0,0,21.8-19.3,16.4-33.5l-73.8,1.8c0,0-5.6,0.2-7.1,5.6c-0.1,0.5-0.3,1.2-0.4,2
                        c-0.1,0.8-0.3,1.7-0.4,2.8c0,0,0,0,0,0.1l0,0.2c-0.4,2.7-3.7,21.1-3,22.3l3.6-0.1l0,0L362.2,174.8z"/>
                    <path 
                      style={{ fill: this.fillColor("headlamp_D")}}
                      onClick={() => this.userClick("headlamp_D")}
                    className="st3" d="M517.6,173.8c0,0-7.3-33.2-31-32.5c-23.7,0.7-71.3,0-71.3,0s-26.6,6.6-33.2,33.1L517.6,173.8z"/>
                    <g>
                        <path d="M568.5,161.8v-3l-2-0.3c0,0.2,0,0.3,0,0.6c0,0.6-0.1,1.2-0.4,1.7c-0.3,0.6-1,1.1-2,1.1c-1.5,0-2.7-1.2-2.7-2.9
                            c0-0.9,0.2-1.6,0.5-1.9l0.8,0.3c-0.2,0.3-0.4,1-0.4,1.7c0,1,0.6,1.8,1.7,1.8c1,0,1.7-0.7,1.7-2.2c0-0.4,0-0.8-0.1-1.1l3.7,0.5
                            v3.7H568.5z"/>
                    </g>
                    <g>
                        <path d="M443.6,161.4h2.1v-3.6h0.7l5,3.5v1.1h-4.8v1.1h-0.8v-1.1h-2.1V161.4z M446.6,161.4h2.6c0.4,0,0.8,0,1.2,0v0
                            c-0.5-0.2-0.8-0.4-1.2-0.6l-2.7-1.9h0V161.4z"/>
                    </g>
                    <g>
                        <path d="M335.1,158.4c-0.2,0.3-0.5,1-0.5,1.7c0,1.4,0.9,1.8,1.5,1.8c1.1,0,1.6-1,1.6-2v-0.6h0.8v0.6c0,0.8,0.4,1.7,1.3,1.7
                            c0.6,0,1.2-0.4,1.2-1.4c0-0.6-0.3-1.2-0.5-1.6l0.8-0.3c0.3,0.4,0.6,1.2,0.6,2c0,1.5-0.9,2.2-1.9,2.2c-0.8,0-1.5-0.5-1.8-1.4h0
                            c-0.2,1-0.9,1.7-2,1.7c-1.2,0-2.3-1-2.3-2.8c0-0.9,0.3-1.6,0.5-2L335.1,158.4z"/>
                    </g>
                    <path className="st4" d="M535.6,508.2v316.5c0,0-135.4,10.5-174.4,0V507.1C361.3,507.1,468.5,495,535.6,508.2z"/>
                    <g>
                        <polygon 
                        style={{ fill: this.fillColor("roofAntenna")}}
                        onClick={() => this.userClick("roofAntenna")}
                        className="st10" points="452.3,796 433.9,796 433.9,807.1 457.3,807.1 457.3,796 			"/>
                        <line onClick={() => this.userClick("roofAntenna")}
                        className="st10" x1="446.3" y1="803.5" x2="456.3" y2="819"/>
                    </g>
                    <g>
                        <path d="M471.4,796.1L471.4,796.1l-0.7-1.4l0.8-0.2l0.9,1.7v0.9h-7.8v-1H471.4z"/>
                        <path d="M464.6,803.2h2.1v-3.6h0.7l5,3.5v1.1h-4.8v1.1h-0.8v-1.1h-2.1V803.2z M467.5,803.2h2.6c0.4,0,0.8,0,1.2,0v0
                            c-0.5-0.2-0.8-0.4-1.2-0.6l-2.7-1.9h0V803.2z"/>
                    </g>
                    <path className="st4" d="M576.8,948.3l-3.8,44.3c0,0-72.2,24.9-246.8,0l-7.3-46.7C318.9,946,433.9,1006,576.8,948.3z"/>
                    <path 
                     style={{ fill: this.fillColor("luggageCoverGlass")}}
                     onClick={() => this.userClick("luggageCoverGlass")}
                    className="st4" d="M566.3,857.6l10.5,76.2c0,0,4.4,13.2,0,14.5c-4.6,1.3-126.7,57.6-257.9-2.3l9.1-81c0,0-0.4-12.3,6.3-8.8
                        C337.8,857.9,535.6,880.8,566.3,857.6z"/>
                    <path 
                     style={{ fill: this.fillColor("luggageCoverSpoiler")}}
                     onClick={() => this.userClick("luggageCoverSpoiler")}
                    className="st4" d="M359.6,824c0,0-23.8-9.3-25.7-3.7c-2,5.7-2,35.2-2,35.2c0.7,1.1,183.6,32.9,234.3,2.1v-39.2
                        C566.3,818.5,398.9,831.1,359.6,824z"/>
                    <g>
                        <path d="M455.3,843.4L455.3,843.4l-0.7-1.4l0.8-0.2l0.9,1.7v0.9h-7.8v-1H455.3z"/>
                        <path d="M455.4,851.9v-3l-2-0.3c0,0.2,0,0.3,0,0.6c0,0.6-0.1,1.2-0.4,1.7c-0.3,0.6-1,1.1-2,1.1c-1.5,0-2.7-1.2-2.7-2.9
                            c0-0.9,0.2-1.6,0.5-1.9l0.8,0.3c-0.2,0.3-0.4,1-0.4,1.7c0,1,0.6,1.8,1.7,1.8c1,0,1.7-0.7,1.7-2.2c0-0.4,0-0.8-0.1-1.1l3.7,0.5
                            v3.7H455.4z"/>
                    </g>
                    <g>
                        <path d="M458.1,911.6L458.1,911.6l-0.7-1.4l0.8-0.2l0.9,1.7v0.9h-7.8v-1H458.1z"/>
                        <path d="M458.4,919.9c0-0.2,0-0.5,0-0.8c-0.3-1.7-1.5-2.5-2.8-2.7v0c0.5,0.4,0.9,1,0.9,1.9c0,1.4-1,2.4-2.5,2.4
                            c-1.4,0-2.7-1-2.7-2.6c0-1.7,1.3-2.8,3.3-2.8c1.5,0,2.7,0.6,3.5,1.3c0.6,0.6,1,1.5,1.2,2.5c0,0.3,0.1,0.6,0.1,0.8H458.4z
                            M453.9,919.6c1.1,0,1.8-0.6,1.8-1.6c0-0.6-0.4-1.2-1-1.5c-0.1-0.1-0.3-0.1-0.5-0.1c-1.3,0-2.2,0.6-2.2,1.7
                            C452,919,452.7,919.6,453.9,919.6z"/>
                    </g>
                    <g>
                        <path 
                        style={{ fill: this.fillColor("rearWiperCover")}}
                        onClick={() => this.userClick("rearWiperCover")}
                        className="st3" d="M494.1,949c0,0,2.6,3,0,8.3l-53.7-1.1v-6.3L494.1,949z"/>
                        <rect 
                        style={{ fill: this.fillColor("rearWiperCover")}}
                        onClick={() => this.userClick("rearWiperCover")}
                        x="425.9" y="946" className="st3" width="14.5" height="14.8"/>
                    </g>
                    <g>
                        <path d="M416.3,948.1L416.3,948.1l-0.7-1.4l0.8-0.2l0.9,1.7v0.9h-7.8v-1H416.3z"/>
                        <path d="M417.3,957h-0.7l-7.1-3.4v-1.1l6.9,3.4h0v-3.8h0.9V957z"/>
                    </g>
                    <path className="st4" d="M302.1,1004.5h299.2c0,0,0.5,57,4,71.5h10v100.5c0,0-3.5,11-11,13.5s-25,0-25,0s-10.5-5-10-14s-2.5-39-2.5-39
                        c-1.4-2.9-209.6-10.2-236,1v42c0,0-3.8,12.2-11.4,11.1s-21.6,0.1-21.6,0.1s-10.5-2.7-11.5-12.2s0-100.5,0-100.5
                        c0.8-1.7,12,3.4,11-17.5c-1.1-22,1.2-56.5,1.2-56.5H302.1z"/>
                    <path className="st4" d="M286.3,1078.5c0,0-2.4,22.2,8.1,36.3v25.5c0,0,5.2,12,30.2,0s235.7-7,245.7-2.3s30.8,17.5,36.3-1.8l-1.4-24.1
                        l9.9-6.1l0.2-30L286.3,1078.5z"/>
                    <path className="st4" d="M572.3,1004.5l-20.5,59.3c0,0-1,7.5-12.5,7.5s-181,0-181,0s-11.5-1.5-14-11.5s-18-55.3-18-55.3H572.3z"/>
                    <path className="st3" d="M394.9,1046.8v-19c0-2.2,1.8-4,4-4h100.4c2.2,0,4,1.8,4,4v19c0,2.2-1.8,4-4,4H398.9
                        C396.7,1050.8,394.9,1049,394.9,1046.8z"/>
                    <polygon 
                     style={{ fill: this.fillColor("interiorBrakeLight_D")}}
                     onClick={() => this.userClick("interiorBrakeLight_D")}
                    className="st3" points="298,1045 298,1045 297.1,1045 298,1010.3 324.6,1011.8 335,1045 		"/>
                    <polygon 
                    style={{ fill: this.fillColor("interiorBrakeLight_L")}}
                    onClick={() => this.userClick("interiorBrakeLight_L")}
                    className="st3" points="600.8,1045.7 600.8,1045.6 601.7,1045.7 600.8,1010.9 574.2,1012.4 563.8,1045.7 		"/>
                    <g>
                        <path d="M590,1023.8L590,1023.8l-0.7-1.4l0.8-0.2l0.9,1.7v0.9h-7.8v-1H590z"/>
                        <path d="M585.2,1027.6c1,0,1.7,0.6,2.1,1.5l0,0c0.4-0.9,1.1-1.2,1.8-1.2c1.2,0,2.1,1,2.1,2.4c0,1.5-0.9,2.3-1.9,2.3
                            c-0.7,0-1.4-0.3-1.8-1.3h0c-0.4,1-1.1,1.6-2,1.6c-1.4,0-2.3-1.2-2.3-2.7C583,1028.5,584,1027.6,585.2,1027.6z M585.2,1031.8
                            c0.9,0,1.4-0.7,1.7-1.7c-0.3-0.9-0.9-1.4-1.6-1.4c-0.8,0-1.5,0.6-1.5,1.6C583.8,1031.1,584.4,1031.8,585.2,1031.8z M589.1,1028.9
                            c-0.8,0-1.2,0.6-1.4,1.5c0.2,0.7,0.7,1.2,1.4,1.2c0.6,0,1.3-0.4,1.3-1.3C590.4,1029.3,589.8,1028.9,589.1,1028.9z"/>
                    </g>
                    <g>
                        <path d="M316,1023.8L316,1023.8l-0.7-1.4l0.8-0.2l0.9,1.7v0.9h-7.8v-1H316z"/>
                        <path d="M309.9,1028.3c0,0.2,0,0.5,0,0.9c0.1,0.6,0.3,1.2,0.8,1.6c0.5,0.5,1.2,0.9,2.1,1v0c-0.5-0.4-0.8-1.1-0.8-1.8
                            c0-1.4,1.1-2.3,2.4-2.3c1.5,0,2.8,1.1,2.8,2.7s-1.3,2.6-3.3,2.6c-1.7,0-2.9-0.6-3.7-1.3c-0.6-0.6-0.9-1.4-1-2.3
                            c-0.1-0.4-0.1-0.7-0.1-1H309.9z M314.4,1028.6c-1,0-1.7,0.6-1.7,1.5c0,0.7,0.3,1.3,0.8,1.5c0.1,0.1,0.2,0.1,0.4,0.1
                            c1.3,0,2.4-0.5,2.4-1.6C316.3,1029.3,315.5,1028.6,314.4,1028.6z"/>
                    </g>
                    <path className="st4" d="M330.4,636.1"/>
                    <path className="st4" d="M324.3,643.8"/>
                    <g>
                        <line className="st5" x1="361.6" y1="824.8" x2="361.6" y2="506.5"/>
                        <rect x="361.3" y="506.5" width="0.5" height="318.3"/>
                    </g>
                    <path className="st4" d="M573.4,644.3"/>
                    <path className="st4" d="M573.4,769.6"/>
                    <path className="st2" d="M361.3,507.5c0,0,94.2-12.6,174.4,0.8"/>
                    <g>
                        <path d="M498.2,417.5L498.2,417.5l-0.7-1.4l0.8-0.2l0.9,1.7v0.9h-7.8v-1H498.2z"/>
                        <path d="M495.4,426.5c-2.7,0-4.1-1-4.1-2.7c0-1.5,1.4-2.6,4-2.6c2.6,0,4.1,1.1,4.1,2.7C499.3,425.6,497.9,426.5,495.4,426.5z
                            M495.3,422.3c-2,0-3.2,0.6-3.2,1.6c0,1.1,1.3,1.6,3.3,1.6c1.9,0,3.2-0.5,3.2-1.6C498.5,422.9,497.4,422.3,495.3,422.3z"/>
                    </g>
                    <g>
                        <path d="M339.9,418.3c0,0.2,0,0.5,0,0.9c0.1,0.6,0.3,1.2,0.8,1.6c0.5,0.5,1.2,0.9,2.1,1v0c-0.5-0.4-0.8-1.1-0.8-1.8
                            c0-1.4,1.1-2.3,2.4-2.3c1.5,0,2.8,1.1,2.8,2.7s-1.3,2.6-3.3,2.6c-1.7,0-2.9-0.6-3.7-1.3c-0.6-0.6-0.9-1.4-1-2.3
                            c-0.1-0.4-0.1-0.7-0.1-1H339.9z M344.4,418.7c-1,0-1.7,0.6-1.7,1.5c0,0.7,0.3,1.3,0.8,1.5c0.1,0.1,0.2,0.1,0.4,0.1
                            c1.3,0,2.4-0.5,2.4-1.6C346.3,419.3,345.5,418.7,344.4,418.7z"/>
                    </g>
                    <path className="st3" d="M570.3,70.3v-35c0,0,0.2-16.3,12.6-20.5h18.6c0,0,10.2-0.2,11.3,12.8l1.1,90.9l-43.6-41.8V70.3z"/>
                    <path className="st3" d="M328.9,70.3v-35c0,0-0.2-16.3-12.6-20.5h-18.6c0,0-10.2-0.2-11.3,12.8l-1.1,90.9l43.6-41.8V70.3z"/>
                    <path className="st3" d="M330.8,1139.5v40.5c0,0-3.7,12.3-11.4,11.1c-7.7-1.2-21.6,0.1-21.6,0.1s-8.7-1.7-11.2-10.5
                        c-2.5-8.7-0.4-88.4-0.4-88.4s2.6,15.5,8.3,22.5v25.5c0,0,5,9.5,20.7,3.8c15.6-5.7,0.3-0.1,0.3-0.1l15.3-5.6L330.8,1139.5z"/>
                    <path className="st3" d="M615.1,1105.9l0.2,70.5c0,0-4.4,11.4-9.4,12.8c-5,1.4-7.6,2.3-26.6,0.7c0,0-10.5-4.1-10-14l-2.5-39l3.5,1
                        c0,0,11.3,5.6,17.7,7.6s16.3,1.2,18.6-9.7l-1.4-23.8L615.1,1105.9z"/>
                    <g>
                        <g>
                            <line className="st4" x1="535.6" y1="508.2" x2="535.6" y2="820.6"/>
                            <rect x="535.4" y="508.2" className="st4" width="0.5" height="312.3"/>
                        </g>
                        <g>
                            <circle 
                              style={{ fill: this.fillColor("roofRail_D")}}
                              onClick={() => this.userClick("roofRail_D")}
                            className="st6" cx="518.4" cy="670" r="10.3"/>
                            <path className="st6" d="M507.9,670c0-5.8,4.7-10.5,10.5-10.5S529,664.1,529,670s-4.7,10.5-10.5,10.5S507.9,675.8,507.9,670z
                                M528.4,670c0-5.5-4.5-10-10-10s-10,4.5-10,10s4.5,10,10,10S528.4,675.4,528.4,670z"/>
                        </g>
                    </g>
                    <circle 
                    style={{ fill: this.fillColor("roofRail_L")}}
                    onClick={() => this.userClick("roofRail_L")}
                    className="st6" cx="380.4" cy="670" r="10.3"/>
                    <g>
                        <path d="M521.6,666.9L521.6,666.9l-0.7-1.4l0.8-0.2l0.9,1.7v0.9h-7.8v-1H521.6z"/>
                        <path d="M516,671c-0.2,0.3-0.5,1-0.5,1.7c0,1.4,0.9,1.8,1.5,1.8c1.1,0,1.6-1,1.6-2v-0.6h0.8v0.6c0,0.8,0.4,1.7,1.3,1.7
                            c0.6,0,1.2-0.4,1.2-1.4c0-0.6-0.3-1.2-0.5-1.6l0.8-0.3c0.3,0.4,0.6,1.2,0.6,2c0,1.5-0.9,2.2-1.9,2.2c-0.8,0-1.5-0.5-1.8-1.4h0
                            c-0.2,1-0.9,1.7-2,1.7c-1.2,0-2.3-1-2.3-2.8c0-0.9,0.3-1.6,0.5-2L516,671z"/>
                    </g>
                    <g>
                        <path d="M383.2,666.5L383.2,666.5l-0.7-1.4l0.8-0.2l0.9,1.7v0.9h-7.8v-1H383.2z"/>
                        <path d="M376.4,670.4h0.6l0.8,0.8c1.9,2,2.9,2.9,4.1,2.9c0.8,0,1.5-0.4,1.5-1.5c0-0.7-0.4-1.3-0.7-1.7l0.7-0.3
                            c0.5,0.5,0.8,1.3,0.8,2.2c0,1.7-1.2,2.4-2.3,2.4c-1.4,0-2.6-1-4.2-2.7l-0.6-0.6h0v3.5h-0.9V670.4z"/>
                    </g>
            </g>
        </svg>
     </>
    )
  }
}
const mapStateToProps = (props) => {
    return {
      lang: props.lang,
    };
  };
  export default connect(mapStateToProps)(PreDamageSVG)
